const PALETTE = ['#34D1BF', '#FFD23F', '#A06CD5', '#FF8E3C', '#9BD96B'];
const PIECE_COUNT = 40;

export interface Confetti {
  readonly element: HTMLElement;
  destroy(): void;
}

export function createConfetti(): Confetti {
  const root = document.createElement('div');
  root.className = 'confetti';
  for (let i = 0; i < PIECE_COUNT; i += 1) {
    const piece = document.createElement('div');
    piece.className = 'confetti-piece';
    const color = PALETTE[i % PALETTE.length] ?? '#34D1BF';
    piece.style.background = color;
    piece.style.left = `${Math.random() * 100}%`;
    piece.style.animationDelay = `${(Math.random() * 2).toFixed(2)}s`;
    piece.style.setProperty('--rot', `${Math.floor(Math.random() * 360)}deg`);
    root.appendChild(piece);
  }
  return {
    element: root,
    destroy(): void {
      root.remove();
    },
  };
}
